import _ from 'lodash';

_.mixin({
  modeBy: (collection, iteratee) =>
    _.chain(collection)
      .countBy(iteratee)
      .toPairs()
      .maxBy(_.last)
      .head()
      .thru(value => (value === 'undefined' ? undefined : value))
      .value()
});

_.mixin({
  mode: collection =>
    _.chain(collection)
      .countBy()
      .toPairs()
      .maxBy(_.last)
      .head()
      .thru(value => (value === 'undefined' ? undefined : value))
      .value()
});

function getModeBy(data, by) {
  let mode = _.modeBy(data, by);
  return !!mode ? +mode : 0;
}

function getMedianBy(data, by) {
  const array = _(data)
    .map(i => {
      return i[by];
    })
    .orderBy()
    .value();
  if (array.length % 2 === 0) {
    return array[Math.ceil(array.length / 2) - 1]; ////(array[array.length / 2] + array[(array.length / 2) - 1]) / 2;
  } else {
    return array[(array.length - 1) / 2];
  }
}

function getMedianFromHistogramBy(data, by, iteratee) {
  const array = [];
  _.forEach(data, d => {
    for (let i = 0; i < d[by]; i++) {
      array.push(d[iteratee]);
    }
  });

  if (array.length % 2 === 0) {
    return array[Math.ceil(array.length / 2) - 1]; //(array[array.length / 2] + array[(array.length / 2) - 1]) / 2;
  } else {
    return array[(array.length - 1) / 2];
  }
}

function getMeanFromHistogramBy(data, by, iteratee) {
  const sum = _.reduce(
    data,
    (sum, d) => {
      if (!!by) {
        return sum + d[by] * d[iteratee];
      } else {
        return sum + d[by] * d[iteratee];
      }
    },
    0
  );

  const length = _.reduce(
    data,
    (sum, d) => {
      return sum + d[by];
    },
    0
  );

  return sum / length;
}

function getModeFromHistogramBy(data, by, iteratee) {
  const array = [];
  _.forEach(data, d => {
    for (let i = 0; i < d[by]; i++) {
      array.push(d[iteratee]);
    }
  });

  const mode = _.mode(array);
  return !!mode ? +mode : 0;
}

function getMeanFromCTHistogramBy(data, by, iteratee) {
  const sum = _.reduce(
    data,
    (sum, d) => {
      return sum + d[iteratee];
    },
    0
  );

  const length = _.reduce(
    data,
    (sum, d) => {
      return sum + d[by];
    },
    0
  );

  return sum / length;
}

export default {
  getModeBy,
  getMedianBy,
  getMedianFromHistogramBy,
  getMeanFromHistogramBy,
  getModeFromHistogramBy,
  getMeanFromCTHistogramBy
};
